module.exports = __webpack_public_path__ + "img/Move_up_black.74d7d4ac.svg";